import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'

const schema: LandingScreenSchema = {
	order: ['LandingLanguageButton', 'LandingHead', 'LandingTitle', 'LandingSubtitle', 'LandingAgeGrid'],

	components: {
		LandingTitle: ({ $t }): LandingComponentsConfig['LandingTitle'] => ({
			title: $t('female_walking.pages.landing.step_1.title'),
			size: 'large',
			uppercase: true,
		}),

		LandingSubtitle: ({ $t }): LandingComponentsConfig['LandingSubtitle'] => ({
			uppercase: true,
			title: $t('female_activity.pages.landing.step_1.subtitle', {
				age: `<b>${$t('female_activity.pages.landing.step_1.age')}</b>`,
			}),
		}),

		LandingAgeGrid: ({ $t }): LandingComponentsConfig['LandingAgeGrid'] => ({
			theme: 'blue',
			ageRanges: [
				{
					value: 40,
					analyticValue: '40-49',
					label: $t('female_yoga.pages.landing.age_range.40_49'),
					img: require('@/assets/landing-age-selection/main-40-49.webp'),
				},
				{
					value: 50,
					analyticValue: '50-59',
					label: $t('female_yoga.pages.landing.age_range.50_59'),
					img: require('@/assets/landing-age-selection/main-50-59.webp'),
				},
				{
					value: 60,
					analyticValue: '60-69',
					label: $t('female_yoga.pages.landing.age_range.60_69'),
					img: require('@/assets/landing-age-selection/main-60-69.webp'),
				},
				{
					value: 70,
					analyticValue: '70+',
					label: $t('female_yoga.pages.landing.age_range.70_80'),
					img: require('@/assets/landing-age-selection/main-70-80.webp'),
				},
			],
			otherAgesButton: {
				data: { value: 18, analyticValue: '18-39' },
				text: $t('female_yoga.pages.landing.im_young'),
			},
		}),
	},
}

export default schema
